import { useSelector } from "react-redux"
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import NavBar from "./components/navbar";
import Footer from "./components/footer";
import Contact from "./components/contact";
import ZigZag from "./commercial/components/zigzag";
import PageShell from "./components/pageShell";

const WhyDrones = () => {

    useEffect(() => {
        AOS.refresh();
    }, [])

    return (
        <>

            <PageShell>
                <div className="core-header vivify fadeIn duration-300 delay-100 title-header-core" >
                    <span>Let’s Check The Stats</span>
                    <h1>Why Drones?</h1>
                    <p>
                        Let’s explore how drone cleaning solutions are faster, more eco friendly and can reach areas traditional cleaners just can’t
                    </p>
                </div>

                <ZigZag>
                    <ZigZag.Card
                        largeGraphic={{
                            video: '/assets/videos/windowclean.mp4',
                            thumbnail: '/assets/videos/thumbnails/windowclean.png',
                        }}
                        title={'Faster Cleaning'}
                        heading={{ text: "5x" }}
                        description={'Drones can clean large surface areas much faster than traditional methods, reducing the cleaning time. They can cover 400-600 square meters per hour​'}
                    />
                    <ZigZag.Card
                        largeGraphic={{ image: '/assets/brighter.png', alt: 'drone displayed' }}
                        title={'Brighter, Cleaner Windows'}
                        heading={{ image: '/assets/sparkles.svg', alt: 'flexibility about us icon' }}
                        description={'Our drone-assisted and Traditional window cleaning services ensure that your windows are spotless and streak-free.'}
                    />

                    <ZigZag.Card
                        largeGraphic={{ video: '/assets/videos/residential.mp4', thumbnail: '/assets/videos/thumbnails/residential.png' }}
                        title={'Less Water'}
                        heading={{ text: "50%" }}
                        description={'Drones use eco-friendly cleaning solutions and optimized water usage, minimizing the ecological footprint. They often use less water and fewer harsh chemicals compared to traditional methods.'}
                    />
                    <ZigZag.Card
                        largeGraphic={{
                            video: '/assets/videos/oil.mp4',
                            thumbnail: '/assets/videos/thumbnails/oil.png'
                        }}
                        title={'Reduced Disruption to Operations'}
                        heading={{ image: '/assets/boltIcon.svg', alt: 'faster bolt icon' }}
                        description={'Our drone-assisted cleaning services are faster and more efficient, allowing us to clean your property without disrupting your daily operations. This means less interference with your employees, customers, or tenants, keeping your business running smoothly.'}
                    />
                </ZigZag>
                <Contact />

            </PageShell>

            {/* <MetaTagHandler >
                {() => (
                    <>
                        <title>Poodle</title>
                    </>
                )}
            </MetaTagHandler>  */}
            {/* <NonLodable /> */}

            {/* <h2><ServerCallHandler id={"getDogHusky"} pathway={'getDog'} data={{breed:'husky'}} fetchHandler={'/api'} overwrite={'getDogHusky.src'} /></h2> */}



        </>
    )
}

export default WhyDrones